export default "__VITE_ASSET__e77507b6__"